module.exports = __webpack_public_path__ + "static/img/B摄像头.db904d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/type-1/B摄像头.png
// module id = +x0E
// module chunks = 0